import React, { useState } from "react";
import { Box } from "@chakra-ui/layout";
import Patterns from "../../patterns/patterns";
import Layout from "../../components/Layout";
import { getContentTypes } from "../../lib/api/contentTypes";
import { getContentNode } from "../../lib/api/contentNodes";
import { getSeoFields } from "../../lib/getSeoFields";
import { NextSeo } from "next-seo";
import { IconButton, useColorMode } from "@chakra-ui/react";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { LetsTalkButton } from "../../components/atoms/buttons/let's-talk-button/let's-talk-button";
import { getFooter, getMainMenu } from "../../lib/api/option-pages";
interface PostProps {
  seo: any;
  post: {
    title: string;
    seo: any;
    pageLayout: {
      flexibleContent: [Record<string, unknown>];
    };
  };
  fields: [Record<string, unknown>];
}
function Post(props: PostProps) {
  if (!props.post) return null;
  const { colorMode, toggleColorMode } = useColorMode();
  const [showCTAButton, setShowCTAButton] = useState(false);

  function isInViewport(el) {
    if (el) {
      const rect = el.getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom >= 0;
    }
  }
  if (typeof window !== "undefined") {
    const cta = document.getElementById("CTABanner");

    document.addEventListener("scroll", function () {
      setShowCTAButton(isInViewport(cta));
    });
  }
  return (
    <Layout seo={props.post.seo}>
      <NextSeo {...props.seo} />
      {props.post.title !== "Contact" && !showCTAButton && (
        <Box position={"fixed"} right={"32px"} top={"85%"} zIndex={10}>
          <LetsTalkButton />
        </Box>
      )}

      <Box>
        {props.fields?.map((post: any, index: number) => {
          return (
            <Patterns
              fieldGroupName={post.__typename}
              post={post}
              key={`${post.fieldGroupName}_${index}`}
            />
          );
        })}
      </Box>
    </Layout>
  );
}

//gets the paths for the slugs
export async function getStaticPaths() {
  let contentTypes = await getContentTypes();
  contentTypes = contentTypes.filter(
    (contentType) =>
      contentType.name !== "post" &&
      contentType.name !== "page" &&
      contentType.name !== "attachment"
  );
  const uris = contentTypes
    ?.map((contentType) => contentType.contentNodes.nodes)
    .flat()
    ?.map(({ uri }) => uri);
  return {
    paths: uris,
    fallback: false,
  };
}

export async function getStaticProps({ params, preview, previewData }) {
  const id = preview ? previewData.id : `${params.postType}/${params.slug}`;
  const idType = preview ? "ID" : "URI";
  const post = await getContentNode(id, idType, preview);
  const seo = !preview ? getSeoFields(post) : null;
  let fields = post.pageLayout.flexibleContent.map((field) => field);
  const mainMenu = await getMainMenu();
  const footer = await getFooter();
  fields.unshift(mainMenu);
  fields.push(footer);

  return { props: { post, seo, fields } };
}

export default Post;
